export enum Scan3dOptionsPanelView {
  None = 'None',
  Scan = 'Scan',
  Station = 'Station',
  Settings = 'Settings',
}
